import Inputs from './Inputs';
import { withFormik } from 'formik';
import debounce from 'lodash/debounce';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import withValidationData from '../../../hocs/withValidationData';
import { validateCreationForm } from '../helpers';
import formatAdventurerName from 'src/common/utils/format-adventurer-name';

const debouncedValidation = debounce(
  (values, props, config) => validateCreationForm(values, props, config), 500
);

/*
 * Inputs drawer.  Prismic user sets a specific number of inputs and labels.
 * For examle 'Fist Name' and 'Last Name' but can include more or be used for
 * other set fields that can be grouped in one drawer.
 * */
const enhance = compose(
  withValidationData,
  withFormik({
    mapPropsToValues: (props) => {
      let values = { base: '' };
      props.drawer.items.map((item) => values[item.drawerKey] = props.productCustomisation[item.drawerKey] || '');
      return (values);
    },
    handleSubmit: (values, formikBag) => {
      const drawer =  formikBag.props.drawer;
      if (drawer.autocapitaliseInputs)   {
        drawer.items.map((item) => values[item.drawerKey] = formatAdventurerName(values[item.drawerKey]));
      }

      formikBag.props.onFormikSubmit(values);
    },
  }),
  withHandlers({
    handleOnChangeItem: props => (event) => {
      props.setFieldValue(event.target.name, event.target.value);
      debouncedValidation({ [event.target.name]: event.target.value }, props, { enableSetErrors: true });
    }
  })
);

export default enhance(Inputs);
